'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SlideCustom = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(SlideCustom, _Component);

  function SlideCustom() {
    (0, _classCallCheck3.default)(this, SlideCustom);
    return (0, _possibleConstructorReturn3.default)(this, (SlideCustom.__proto__ || (0, _getPrototypeOf2.default)(SlideCustom)).apply(this, arguments));
  }

  (0, _createClass3.default)(SlideCustom, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          show = _props.show,
          title = _props.title,
          onHide = _props.onHide,
          contentClassName = _props.contentClassName;

      var styles = require('./SlideCustom.scss');
      return _react2.default.createElement(
        'div',
        { className: styles.menuCustom + ' ' + (show ? styles.show : '') },
        _react2.default.createElement('div', { className: styles.overlay, onClick: onHide }),
        _react2.default.createElement(
          'div',
          { className: styles.content + ' slideBottom' },
          _react2.default.createElement(
            'h3',
            { onClick: onHide },
            title
          ),
          _react2.default.createElement(
            'div',
            { className: 'scroll bottom  ' + contentClassName },
            this.props.children
          )
        )
      );
    }
  }]);
  return SlideCustom;
}(_react.Component), _class.propTypes = {
  show: _react.PropTypes.bool,
  title: _react.PropTypes.string,
  contentClassName: _react.PropTypes.string,
  children: _react.PropTypes.array.isRequired,
  onHide: _react.PropTypes.func
}, _temp);
exports.default = SlideCustom;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Common/SlideCustom.js
// module id = 1583
// module chunks = 0